var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === '1')?_c('F10Fund'):_vm._e(),(_vm.type === '0')?_c('F10Stock'):_vm._e(),_c('Disclaimer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }